import { Link as RouterLink } from 'react-router-dom';

import { Button, Stack, Typography } from '@mui/material';

import useLocales from '@src/locales/use-locales';
import paths from '@src/routes/routes';

const PasswordResetSuccessfully = () => {
  const { t } = useLocales();
  return (
    <Stack justifyContent="center" alignItems="center" spacing={3}>
      <Typography variant="subtitle1" color="primary">
        {t('passwordResetSuccessfully.title')}
      </Typography>
      <Typography variant="body1">
        {t('passwordResetSuccessfully.WeHaveSendYouAResetLink', {
          ns: 'common',
        })}
      </Typography>
      <Button component={RouterLink} to={paths.signIn} variant="contained">
        {t('buttons.returnToSignIn')}
      </Button>
    </Stack>
  );
};

export default PasswordResetSuccessfully;
